<template>
<div class="chapter">
<div class="inner_page">
<p class="C124"><em><a id="page_X"></a>“Papa seems so quietly happy</em>.”</p>
<p class="C125">—Louisa MacDonald, May 4, 1872, from Deskford (near Cullen)</p>
<p class="C126">“<em>Papa does enjoy this place so much</em>.”</p>
<p class="C125">—Louisa MacDonald, May 6, 1872 from the Seafield Arms Hotel, Cullen</p>
<p class="C126">“<em>Papa oh! so jolly &amp; bright &amp; happy…Papa was taken for Lord Seafield yesterday</em>.”</p>
<p class="C125">—Louisa MacDonald, Sept. 2, 1873, from Cullen</p>
<p class="C126">“<em>Papa is very poorly. He ought to go to Cullen for a week I think</em>.”</p>
<p class="C125">—Louisa MacDonald, October 5, 1873, from London</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part0005.vue?5a79f736